var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 84,
    viewBox: "0 0 218 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.1477 77.9757C83.7836 74.424 100.224 70.0116 116.403 64.7564C132.52 59.6019 148.36 53.6188 163.86 46.831C198.508 31.5231 220.641 15.7833 217.746 6.79854C214.878 -2.09805 188.223 -2.01433 151.729 5.59558C152.27 6.27124 152.796 6.95864 153.307 7.6578C183.958 1.78402 205.928 2.09247 208.387 9.80814C210.899 17.5943 192.885 30.8973 164.067 44.1783C148.335 51.3253 132.198 57.5431 115.737 62.7999C99.2243 68.1824 82.4081 72.5862 65.3763 75.9884C34.3682 82.0032 12.0849 81.7168 9.59084 73.9526C7.12323 66.281 24.63 53.2159 52.7959 40.1112C52.7959 39.2299 52.8312 38.3751 52.8885 37.5026C18.9589 52.6299 -2.60618 68.0921 0.253601 76.971C3.18388 85.9073 30.2218 85.7575 67.1477 77.9757Z",
    fill: "#84E2D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector17);
export default __webpack_public_path__ + "static/media/vector-17.4b150bb4e14ed5890b6065c74e48e9a0.svg";
export { ForwardRef as ReactComponent };